/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NmfcSubItemChoice } from './NmfcSubItemChoice';
import {
    NmfcSubItemChoiceFromJSON,
    NmfcSubItemChoiceFromJSONTyped,
    NmfcSubItemChoiceToJSON,
    NmfcSubItemChoiceToJSONTyped,
} from './NmfcSubItemChoice';

/**
 * 
 * @export
 * @interface LookupNmfcCodeForLineItemResponse
 */
export interface LookupNmfcCodeForLineItemResponse {
    /**
     * Did we find a valid nmfc code from this?
     * @type {boolean}
     * @memberof LookupNmfcCodeForLineItemResponse
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof LookupNmfcCodeForLineItemResponse
     */
    freightClass?: string;
    /**
     * 
     * @type {string}
     * @memberof LookupNmfcCodeForLineItemResponse
     */
    nmfcWithSubItem?: string;
    /**
     * 
     * @type {string}
     * @memberof LookupNmfcCodeForLineItemResponse
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof LookupNmfcCodeForLineItemResponse
     */
    errorMessage?: string;
    /**
     * 
     * @type {Array<NmfcSubItemChoice>}
     * @memberof LookupNmfcCodeForLineItemResponse
     */
    subItemChoices?: Array<NmfcSubItemChoice>;
}

/**
 * Check if a given object implements the LookupNmfcCodeForLineItemResponse interface.
 */
export function instanceOfLookupNmfcCodeForLineItemResponse(value: object): value is LookupNmfcCodeForLineItemResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    return true;
}

export function LookupNmfcCodeForLineItemResponseFromJSON(json: any): LookupNmfcCodeForLineItemResponse {
    return LookupNmfcCodeForLineItemResponseFromJSONTyped(json, false);
}

export function LookupNmfcCodeForLineItemResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LookupNmfcCodeForLineItemResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'freightClass': json['freightClass'] == null ? undefined : json['freightClass'],
        'nmfcWithSubItem': json['nmfcWithSubItem'] == null ? undefined : json['nmfcWithSubItem'],
        'description': json['description'] == null ? undefined : json['description'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'subItemChoices': json['subItemChoices'] == null ? undefined : ((json['subItemChoices'] as Array<any>).map(NmfcSubItemChoiceFromJSON)),
    };
}

  export function LookupNmfcCodeForLineItemResponseToJSON(json: any): LookupNmfcCodeForLineItemResponse {
      return LookupNmfcCodeForLineItemResponseToJSONTyped(json, false);
  }

  export function LookupNmfcCodeForLineItemResponseToJSONTyped(value?: LookupNmfcCodeForLineItemResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'freightClass': value['freightClass'],
        'nmfcWithSubItem': value['nmfcWithSubItem'],
        'description': value['description'],
        'errorMessage': value['errorMessage'],
        'subItemChoices': value['subItemChoices'] == null ? undefined : ((value['subItemChoices'] as Array<any>).map(NmfcSubItemChoiceToJSON)),
    };
}

